// x-cookie-utils.js

/*
Used to set design-cookie to override host with x1 design
Imported from html: /vrtx/set-design.html
*/

window.cookieUtils = {
  create: function(name,value,days,domain,isSecure) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    } else {
      expires = "";
    }
    if(domain){
      expires = expires +  ";domain=" + domain
    }
    document.cookie = name+"="+value+expires+"; path=/"  + (((typeof forceSecure === "boolean" && forceSecure) || location.protocol === "https:") ? ";secure" : "");
  },
  createExact: function(name,value,day,month,year,domain,isSecure) {
    var expires = "";
    if (day && month && year) {
      var date = new Date(year, month - 1, day);
      expires = "; expires="+date.toString();
    } else {
      expires = "";
    }
    if(domain){
      expires = expires +  ";domain=" + domain
    }
    document.cookie = name+"="+value+expires+"; path=/"  + (((typeof forceSecure === "boolean" && forceSecure) || location.protocol === "https:") ? ";secure" : "");
  },
  createSeconds: function(name,value,seconds,domain) {
    var expires = "";
    if (seconds) {
      var date = new Date();
      date.setTime(date.getTime()+(seconds*1000));
      expires = "; expires="+date.toGMTString();
    } else {
      expires = "";
    }
    if(domain){
      expires = expires +  ";domain=" + domain
    }
    document.cookie = name+"="+value+expires+"; path=/";
  },
  read: function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0, len = ca.length; i < len; i++) {
      var c = ca[i];
      var cLen = c.length;
      while (c.charAt(0)==' ') c = c.substring(1, cLen);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, cLen);
    }
    return null;
  },
  erase: function(name,domain) {
    cookieUtils.create(name,"",-1,domain);
  }
};
